import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';

export default WithApp(function ModalPurchOrder(props) {
  const purchOrder = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [providers, setProvider] = useState([]);
  const [warehouse, setAlmacenes] = useState([]);
  const [selectedWarehouse, setSelectedAlmacenes] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listProvider() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProvider(response.data);
  }
  async function listAlmacen() {
    let response = await wsGetAll('logi/warehouse?warehouse_type=N');
    if (response.success) setAlmacenes(response.data);
  }

  useEffect(() => {
    if (purchOrder.open) setBPartnerSelect(undefined);
  }, [purchOrder.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_business_partner_id: null,
        logi_warehouse_id: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            CardCode: item.PROVEEDOR,
            WhsCode: item.ALMACEN.toString(),
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.base_business_partner_id) {
      setDataChanging((prev) => ({
        ...prev,
        base_business_partner_id: bPartnerSelect?.base_business_partner_id || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listProvider();listAlmacen();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);
  return (
    <>
      <Modal
        title={`Nueva orden de compra`}
        model={{ open: purchOrder.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.base_business_partner_id
            ? 'purch/purchase-order'
            : 'purch/purchase-order/multiple'
        }
        dataForce={
          dataChanging.base_business_partner_id
            ? {
              base_business_partner_id: dataChanging.base_business_partner_id,
              // logi_warehouse_id: dataChanging.logi_warehouse_id,
              logi_warehouse_id: selectedWarehouse.map((f) => f.id),
              }
            : {
                base_business_partner_id: purchOrder.valueSearch?.base_business_partner_id,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={providers}
            getOptionLabel={(item) => `${item.CardName} (Código: ${item.CardCode})`}
            renderInput={(params) => (
              <TextField {...params} label="Proveedor" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('base_business_partner_id', item?.id); setDataImport(null);}}
            value={providers.find((provider) => provider.id === dataChanging.base_business_partner_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['PROVEEDOR','ALMACEN']}
            sortDuplicate="PROVEEDOR"
            downTemplate={{
              fileNameDown: `${moment(purchOrder?.valueSearch?.periodo).format('YYYY-MM')}_Plantilla de orden de compra`,
              fields: ['PROVEEDOR','ALMACEN']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.base_business_partner_id ? (
          <>
            {/* <Autocomplete
              disableClearable
              options={warehouse}
              getOptionLabel={(item) => `${item.WhsName}`}
              renderInput={(params) => (
                <TextField {...params} label="Almacén" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('logi_warehouse_id', item?.id); setDataImport(null);}}
              value={warehouse.find((warehouse) => warehouse.id === dataChanging.logi_warehouse_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
              disabled={!warehouse.length}
            /> */}
            <MultiComplete
              label="Almacenes"
              selectAll
              limitTags={1}
              textField="WhsName"
              options={warehouse}
              selected={selectedWarehouse}
              setSelected={setSelectedAlmacenes}
              disabled={!warehouse.length}
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
